import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { NgxEditorModule } from 'ngx-editor';
import { AuthGuard } from './guards/auth.guard';
import { AppInterceptor } from './guards/app.interceptor';
import { NgxCurrencyModule } from 'ngx-currency';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { LayoutComponent } from './components/layout/layout.component';
import { MenuComponent } from './components/menu/menu.component';
import { ImageUploadComponent } from './components/imageupload/imageupload.component';

import { AuthenticationService } from './services/authentication.service';
import { CommonService } from './services/common.service';
import { CompanyService } from './services/company.service';
import { CategoryService } from './services/category.service';
import { ContactService } from './services/contact.service';
import { OrganizationService } from './services/organization.service';
import { ProvinceService } from './services/province.service';
import { PermissionService } from './services/permission.service';
import { DistrictService } from './services/district.service';
import { WardService } from './services/ward.service';
import { PositionService } from './services/position.service';
import { ImageUploadService } from './services/imageupload.service';
import { EmailService } from './services/email.service';
import { BankService } from './services/bank.service';
import { OrderstatusService } from './services/orderstatus.service';
import { CustomerlevelService } from './services/customerlevel.service';
import { ColorpaintService } from './services/colorpaint.service';
import { ReportsService } from './services/reports.service';
import { UserModel } from './models/user.model';
import { PermissionModel } from './models/permission.model';
import { PermissionSetModel } from './models/permissionSet.model';
import {
  MatButtonModule, MatCardModule, MatDatepickerModule, MatInputModule,
  MatFormFieldModule, MatExpansionModule, MatTabsModule, MatTableModule, MatCheckboxModule,
  MatSelectModule, MatTooltipModule, MatNativeDateModule, MatChipsModule, MatAutocompleteModule, MatPaginatorModule, MatSortModule
} from '@angular/material';

import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SuccessComponent } from './toast/success/success.component';
import { WarningComponent } from './toast/warning/warning.component';
import { FailComponent } from './toast/fail/fail.component';
import { ngfModule, ngf } from 'angular-file';
import { NoteService } from './services/note.service';
import { ChartModule } from 'angular-highcharts';
import { ImageCropperModule } from 'ng2-img-cropper';
import { PopupComponent } from './components/popup/popup.component';
import { ChangepasswordComponent } from './components/changepassword/changepassword.component';
import { ChangepasswordsuccessComponent } from './components/changepasswordsuccess/changepasswordsuccess.component';
import { ApproveRejectPopupComponent } from './components/approverejectpopup/approverejectpopup.component';
import { TreeviewModule } from 'ngx-treeview';
import { ContactpopupComponent } from './components/contactpopup/contactpopup.component';
import { BankpopupComponent } from './components/bankpopup/bankpopup.component';
import { NumberToStringPipe } from './ConvertMoneyToString/numberToString.pipe';
import { OrganizationpopupComponent } from './components/organizationpopup/organizationpopup.component';
import { NotificationService } from './services/notification.service';


export const customCurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  allowZero: true,
  decimal: '',
  precision: 0,
  prefix: '',
  suffix: '',
  thousands: ',',
  nullable: true
};
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    HttpModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    MatButtonModule,
    MatCardModule,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatTabsModule,
    MatTableModule,
    MatCheckboxModule,
    MatSelectModule,
    MatSnackBarModule,
    MatRadioModule,
    MatTooltipModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatPaginatorModule,
    NgxEditorModule,
    MatSortModule,
    ngfModule,
    ChartModule,
    MatDialogModule,
    ImageCropperModule,
    TreeviewModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig)
  ],
  entryComponents: [SuccessComponent, FailComponent, WarningComponent, ImageUploadComponent, PopupComponent, ApproveRejectPopupComponent, OrganizationpopupComponent],
  declarations: [AuthGuard, HeaderComponent, FooterComponent, UserModel, AuthenticationService, AppInterceptor, CommonService, ColorpaintService, ReportsService,
    CompanyService, ContactService, CategoryService, UserModel, PermissionModel, PermissionSetModel, LayoutComponent, MenuComponent, SuccessComponent,
    FailComponent, WarningComponent, OrganizationService, NoteService, ProvinceService, DistrictService, WardService, PositionService,
      ImageUploadService, ImageUploadComponent, PopupComponent, PermissionService, EmailService, BankService, ChangepasswordComponent,
    ChangepasswordsuccessComponent, WarningComponent, ApproveRejectPopupComponent,
    ContactpopupComponent, BankpopupComponent, OrderstatusService, NumberToStringPipe, CustomerlevelService, OrganizationpopupComponent,
    NotificationService
  ],
  exports: [
    CommonModule,
    RouterModule,
    HttpModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    AuthGuard,
    HeaderComponent,
    FooterComponent,
    LayoutComponent,
    UserModel,
    AuthenticationService,
    CommonService,
    CompanyService,
    ContactService,
    CategoryService,
    ColorpaintService,
    ReportsService,
    MatButtonModule,
    MatCardModule,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatTabsModule,
    MatTableModule,
    MatCheckboxModule,
    MatSelectModule,
    MatSnackBarModule,
    MatRadioModule,
    MatTooltipModule,
    MatNativeDateModule,
    MatChipsModule,
    MatAutocompleteModule,
    NgxEditorModule,
    MatPaginatorModule,
    MatSortModule,
    ngfModule,
    ChartModule,
    MatDialogModule,
    ImageCropperModule,
    ImageUploadComponent,
    PopupComponent,
    ChangepasswordComponent,
    ChangepasswordsuccessComponent,
    ApproveRejectPopupComponent,
    TreeviewModule,
    NgxCurrencyModule,
    NumberToStringPipe
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptor,
      multi: true
    },
    CommonService,
    ImageUploadService,
    AuthenticationService,
    EmailService,
    CompanyService,
    ReportsService,
    OrganizationService,
    //ColorpaintService,
    NotificationService
  ],
  bootstrap: [ImageUploadComponent, PopupComponent, ChangepasswordComponent, ChangepasswordsuccessComponent, ApproveRejectPopupComponent]
})
export class SharedModule {

}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts